import React, { useEffect, useState } from "react";
import StablePrime from "../components/Tables/StablePrime";
import { useParams, useLocation } from "react-router-dom";
import queryString from "query-string";

function ReportTom({ setPageHeader, urlData }) {
  setPageHeader();
  let { typ } = useParams();
  let { subtyp } = useParams();
  const [loading, setLoading] = useState(true);
  const [paramData, setParamsData] = useState();
  const { search } = useLocation();
  const searchParams = queryString.parse(search);


  useEffect(() => {
    setLoading(true);
    if (urlData) {
      setParamsData(urlData);
    } else {
      let _urlData = { ...searchParams, typ: typ, subTyp: subtyp };
      setParamsData(_urlData);
    };
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [typ, subtyp, urlData]);


  return !loading && (
    <div>
      {
        paramData.tblQty ?
          Array.from({ length: searchParams.tblQty }).map((_, i) => (
            <div style={{ minHeight: 400, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <StablePrime editSingleColumn={true} url="/report/reporttom"
                data={{ ...paramData, tblIndx: `table-${i}` }}
                zenTable={true}
                identity="" />
            </div>
          )) :
          <StablePrime editSingleColumn={true} url="/report/reporttom"
            data={paramData}
            zenTable={true}
            identity="" />
      }
      {/* <Stable url="report/tom" data={{}} identity="perfparam" /> */}
    </div>
  );
}

export default ReportTom;
